import weddingPhoto from "../assets/images/weddingPhoto.jpg";
import privacyAR from "../assets/images/framed-features/security/security-AR.webp";
import privacyIT from "../assets/images/framed-features/security/security-IT.webp";
import privacyFR from "../assets/images/framed-features/security/security-FR.webp";
import privacyES from "../assets/images/framed-features/security/security-ES.webp";
import privacyEN from "../assets/images/framed-features/security/security-EN.webp";
import profilesEN from "../assets/images/framed-features/profiles/profiles-EN.webp";
import profilesFR from "../assets/images/framed-features/profiles/profiles-FR.webp";
import profilesES from "../assets/images/framed-features/profiles/profiles-ES.webp";
import profilesAR from "../assets/images/framed-features/profiles/profiles-AR.webp";
import profilesIT from "../assets/images/framed-features/profiles/profiles-IT.webp";
import membershipEN from "../assets/images/framed-features/membership/membership-EN.webp";
import membershipFR from "../assets/images/framed-features/membership/membership-FR.webp";
import membershipES from "../assets/images/framed-features/membership/membership-ES.webp";
import membershipAR from "../assets/images/framed-features/membership/membership-AR.webp";
import membershipIT from "../assets/images/framed-features/membership/membership-IT.webp";
import activityEN from "../assets/images/framed-features/activity/activity-EN.webp";
import activityFR from "../assets/images/framed-features/activity/activity-FR.webp";
import activityES from "../assets/images/framed-features/activity/activity-ES.webp";
import activityAR from "../assets/images/framed-features/activity/activity-AR.webp";
import activityIT from "../assets/images/framed-features/activity/activity-IT.webp";
import filtersEN from "../assets/images/framed-features/filters/filters-EN.webp";
import filtersFR from "../assets/images/framed-features/filters/filters-FR.webp";
import filtersES from "../assets/images/framed-features/filters/filters-ES.webp";
import filtersAR from "../assets/images/framed-features/filters/filters-AR.webp";
import filtersIT from "../assets/images/framed-features/filters/filters-IT.webp";
import compatibilityEN from "../assets/images/framed-features/compatibility/compatibility-EN.webp";
import compatibilityFR from "../assets/images/framed-features/compatibility/compatibility-FR.webp";
import compatibilityES from "../assets/images/framed-features/compatibility/compatibility-ES.webp";
import compatibilityAR from "../assets/images/framed-features/compatibility/compatibility-AR.webp";
import compatibilityIT from "../assets/images/framed-features/compatibility/compatibility-IT.webp";
import dynamicCardsEN from "../assets/images/framed-features/dynamicCards/dynamicCards-EN.webp";
import dynamicCardsFR from "../assets/images/framed-features/dynamicCards/dynamicCards-FR.webp";
import dynamicCardsES from "../assets/images/framed-features/dynamicCards/dynamicCards-ES.webp";
import dynamicCardsAR from "../assets/images/framed-features/dynamicCards/dynamicCards-AR.webp";
import dynamicCardsIT from "../assets/images/framed-features/dynamicCards/dynamicCards-IT.webp";
import dynamicCardEN from "../assets/images/framed-features/dynamicCard/dynamicCard-EN.webp";
import dynamicCardFR from "../assets/images/framed-features/dynamicCard/dynamicCard-FR.webp";
import dynamicCardES from "../assets/images/framed-features/dynamicCard/dynamicCard-ES.webp";
import dynamicCardAR from "../assets/images/framed-features/dynamicCard/dynamicCard-AR.webp";
import dynamicCardIT from "../assets/images/framed-features/dynamicCard/dynamicCard-IT.webp";

const backendUrl =
  process.env.REACT_APP_BACKEND || "https://app.mabrook.ma/api";
if (!backendUrl) {
  throw new Error(
    "REACT_APP_BACKEND is missing from the environment configuration.",
  );
}
export const hostAndBackendPort = backendUrl.replace(/\/+$/, "");

//export const hostAndBackendPort = "https://www.mabrook.ma/api/";
//export const hostAndBackendPort = "http://localhost:4000/api/";
export const mabrookEmail = "contact@mabrook.ma";

export const features = [
  {
    title: {
      en: "Create Your Profile",
      fr: "Créer votre Profil",
      es: "Crear Perfil",
      ar: "إنشاء ملف شخصي",
      it: "Creare Profilo",
    },
    description: {
      en: "Show who you really are: your values, your family, your goals, and what you're looking for, so the right people can find you.",
      fr: "Montrez qui vous êtes vraiment : vos origines, vos valeurs, votre famille et ce que vous recherchez, afin que les bonnes personnes vous trouvent.",
      es: "Muestra quién eres realmente: tus orígenes, tus valores, tu familia y lo que buscas, para que las personas adecuadas te encuentren.",
      ar: "أظهر من أنت حقًا: خلفيتك وقيمك وعائلتك وما تبحث عنه، حتى يجدك الأشخاص المناسبون.",
      it: "Mostra chi sei davvero: le tue origini, i tuoi valori, la tua famiglia e ciò che cerchi, così le persone giuste possono trovarti.",
    },
    images: [
      {
        en: profilesEN,
        fr: profilesFR,
        es: profilesES,
        ar: profilesAR,
        it: profilesIT,
      },
    ],
  },
  {
    title: {
      en: "Your privacy and reputation, protected",
      fr: "Votre vie privée et votre réputation, protégées",
      es: "Tu privacidad y reputación, protegidas",
      ar: "خصوصيتك وسمعتك محميتان",
      it: "La tua privacy e la tua reputazione, protette",
    },
    description: {
      en: "Customize your privacy settings to control the visibility of your photos and information. Choose who can see your profile, hide from specific users, and block unwanted members.",
      fr: "Personnalisez vos paramètres de confidentialité pour contrôler la visibilité de vos photos et informations. Choisissez qui peut voir votre profil, cachez-vous de certains utilisateurs et bloquez les membres indésirables.",
      es: "Personalice la configuración de privacidad para controlar la visibilidad de sus fotos e información. Elija quién puede ver su perfil, ocúltese de usuarios específicos y bloquee miembros no deseados.",
      ar: "قم بتخصيص إعدادات الخصوصية للتحكم في رؤية صورك ومعلوماتك. اختر من يمكنه رؤية ملفك الشخصي، واختر الإخفاء من بعض المستخدمين، وقم بحظر الأعضاء غير المرغوب فيهم.",
      it: "Personalizza le impostazioni della privacy per controllare la visibilità delle tue foto e informazioni. Scegli chi può vedere il tuo profilo, nasconditi da utenti specifici e blocca i membri indesiderati.",
    },
    images: [
      {
        en: privacyEN,
        fr: privacyFR,
        es: privacyES,
        ar: privacyAR,
        it: privacyIT,
      },
    ],
  },
  {
    title: {
      en: "Find exactly who you're looking for",
      fr: "Trouvez exactement la personne que vous recherchez",
      es: "Encuentra exactamente a la persona que buscas",
      ar: "اعثر على الشخص الذي تبحث عنه بالضبط",
      it: "Trova esattamente la persona che stai cercando",
    },
    description: {
      en: "Refine your search with a range of filters, including basic and advanced criteria, to find matches tailored to your preferences.",
      fr: "Affinez votre recherche avec une gamme de filtres, y compris des critères de base et avancés, pour trouver des correspondances adaptées à vos préférences.",
      es: "Refine su búsqueda con una variedad de filtros, incluidos criterios básicos y avanzados, para encontrar coincidencias adaptadas a sus preferencias.",
      ar: "قم بتنقيح بحثك باستخدام مجموعة من المرشحات ، بما في ذلك المعايير الأساسية والمتقدمة ، للعثور على تطابقات مصممة وفقًا لتفضيلاتك.",
      it: "Affina la tua ricerca con una serie di filtri, inclusi criteri di base e avanzati, per trovare corrispondenze su misura per le tue preferenze.",
    },
    images: [
      {
        en: filtersEN,
        fr: filtersFR,
        es: filtersES,
        ar: filtersAR,
        it: filtersIT,
      },
    ],
  },
  {
    title: {
      en: "Know you're compatible before the first message",
      fr: "Découvrez si vous êtes compatibles avant le premier message",
      es: "Descubre si son compatibles antes del primer mensaje",
      ar: "اعرف مدى توافقكما قبل أول رسالة",
      it: "Scopri se siete compatibili prima del primo messaggio",
    },
    description: {
      en: "Answer a compatibility questionnaire and see how closely your values, family, lifestyle, and goals align, so you focus on the right people.",
      fr: "Répondez à un questionnaire de compatibilité et voyez à quel point vos valeurs, votre famille, votre mode de vie et vos objectifs sont alignés, afin de vous concentrer sur les bonnes personnes.",
      es: "Responde un cuestionario de compatibilidad y descubre qué tan alineados están sus valores, familia, estilo de vida y objetivos, para que te enfoques en las personas adecuadas.",
      ar: "أجب عن استبيان التوافق واكتشف مدى توافق القيم والعائلة ونمط الحياة والأهداف، حتى تركّز على الأشخاص المناسبين.",
      it: "Rispondi a un questionario di compatibilità e scopri quanto sono allineati i vostri valori, la famiglia, lo stile di vita e gli obiettivi, così puoi concentrarti sulle persone giuste.",
    },
    images: [
      {
        en: compatibilityEN,
        fr: compatibilityFR,
        es: compatibilityES,
        ar: compatibilityAR,
        it: compatibilityIT,
      },
    ],
    //comingSoon: true,
  },
  {
    title: {
      en: "Show the real you",
      fr: "Montrez qui vous êtes vraiment",
      es: "Muestra tu verdadero yo",
      ar: "أظهر شخصيتك الحقيقية",
      it: "Mostra chi sei davvero",
    },
    description: {
      en: "Share your lifestyle, beliefs, family, and personality through profile cards, and reveal each one only to the people you choose.",
      fr: "Partagez votre mode de vie, vos croyances, votre famille et votre personnalité à travers des cartes de profil, et révélez chacune d’elles uniquement aux personnes que vous choisissez.",
      es: "Comparte tu estilo de vida, tus creencias, tu familia y tu personalidad a través de tarjetas de perfil, y revela cada una solo a las personas que elijas.",
      ar: "شارك نمط حياتك ومعتقداتك وعائلتك وشخصيتك من خلال بطاقات الملف الشخصي، واكشف كل بطاقة فقط للأشخاص الذين تختارهم.",
      it: "Condividi il tuo stile di vita, le tue convinzioni, la tua famiglia e la tua personalità attraverso le schede del profilo, e rivela ciascuna solo alle persone che scegli.",
    },
    images: [
      {
        en: dynamicCardsEN,
        fr: dynamicCardsFR,
        es: dynamicCardsES,
        ar: dynamicCardsAR,
        it: dynamicCardsIT,
      },
      {
        en: dynamicCardEN,
        fr: dynamicCardFR,
        es: dynamicCardES,
        ar: dynamicCardAR,
        it: dynamicCardIT,
      },
    ],
  },
  {
    title: {
      en: "Stay in control of every connection",
      fr: "Gardez le contrôle de chaque connexion",
      es: "Mantén el control de cada conexión",
      ar: "تحكّم في كل تواصل",
      it: "Mantieni il controllo di ogni connessione",
    },
    description: {
      en: "Keep everyone in one place: who you've liked, who's liked you, your mutual matches, and the people you've passed on or blocked. No confusion, full control.",
      fr: "Gardez tout le monde au même endroit : les personnes que vous avez likées, celles qui vous ont liké, vos matchs mutuels, ainsi que les profils que vous avez passés ou bloqués. Aucune confusion, vous gardez le contrôle.",
      es: "Ten a todos en un solo lugar: a quién le diste like, quién te dio like, tus matches mutuos y las personas que pasaste o bloqueaste. Sin confusión, con control total.",
      ar: "احتفظ بكل الأشخاص في مكان واحد: من أعجبت بهم، ومن أعجبوا بك، والمطابقات المتبادلة، والأشخاص الذين تجاوزتهم أو حظرتهم. بدون ارتباك، وتحكّم كامل.",
      it: "Tieni tutto in un unico posto: chi ti è piaciuto, a chi sei piaciuto, i tuoi match reciproci e le persone che hai scartato o bloccato. Nessuna confusione, pieno controllo.",
    },
    images: [
      {
        en: activityEN,
        fr: activityFR,
        es: activityES,
        ar: activityAR,
        it: activityIT,
      },
    ],
  },
  {
    title: {
      en: "Choose the Membership That Fits You",
      fr: "Choisissez l’Abonnement qui Vous Convient",
      es: "Elige la Membresía que Más te Conviene",
      ar: "اختر العضوية التي تناسبك",
      it: "Scegli l’Abbonamento Più Adatto a Te",
    },
    description: {
      en: "Explore the available membership options, compare what each plan includes, and choose the level of access that best suits your needs.",
      fr: "Découvrez les différentes formules d’abonnement, comparez les avantages inclus dans chacune et choisissez celle qui correspond le mieux à vos besoins.",
      es: "Descubre las opciones de membresía disponibles, compara lo que incluye cada plan y elige el nivel de acceso que mejor se adapte a tus necesidades.",
      ar: "اكتشف خيارات العضوية المتاحة، وقارن المزايا التي تتضمنها كل خطة، واختر مستوى الوصول الذي يناسب احتياجاتك.",
      it: "Scopri le opzioni di abbonamento disponibili, confronta i vantaggi inclusi in ciascun piano e scegli il livello di accesso più adatto alle tue esigenze.",
    },
    images: [
      {
        en: membershipEN,
        fr: membershipFR,
        es: membershipES,
        ar: membershipAR,
        it: membershipIT,
      },
    ],
  },
];

// Web prices are in MAD, set for the Moroccan market rather than converted from
// the App Store USD prices. They sit slightly below the iOS prices because the
// web channel carries no store commission. Never surface this difference to iOS
// users: App Store guideline 3.1.3 forbids steering them off-platform.
export const subscriptionPrices = {
  Standard: {
    "1 month": 95,
    "3 months": 239,
    "12 months": 659,
  },
  Premium: {
    "1 month": 139,
    "3 months": 379,
    "12 months": 1099,
  },
};

export const CURRENCY = "MAD";

export const membershipTiers = [
  {
    id: "standard",
    priceKey: "Standard",
    labelKey: "Standard",
    descriptionKey: "All paid features except the matching algorithm.",
  },
  {
    id: "premium",
    priceKey: "Premium",
    labelKey: "Premium",
    descriptionKey: "Everything in Standard plus the matching algorithm.",
    badgeKey: "Complete experience",
  },
];

export const membershipDurations = [
  {
    id: "monthly",
    priceKey: "1 month",
    months: 1,
    descriptionKey: "A flexible way to get started",
    label: {
      en: "1 month",
      fr: "1 mois",
      es: "1 mes",
      ar: "شهر واحد",
      it: "1 mese",
    },
  },
  {
    id: "quarterly",
    priceKey: "3 months",
    months: 3,
    badgeKey: "Most popular",
    descriptionKey: "Enough time to explore with intention",
    label: {
      en: "3 months",
      fr: "3 mois",
      es: "3 meses",
      ar: "3 أشهر",
      it: "3 mesi",
    },
  },
  {
    id: "annual",
    priceKey: "12 months",
    months: 12,
    badgeKey: "Best value",
    descriptionKey: "The best value for the full experience",
    label: {
      en: "12 months",
      fr: "12 mois",
      es: "12 meses",
      ar: "12 شهرًا",
      it: "12 mesi",
    },
  },
];

export const membershipFeatures = [
  {
    id: "profile",
    labelKey: "Create a profile",
    free: true,
    standard: true,
    premium: true,
  },
  {
    id: "messaging",
    labelKey: "Messaging",
    free: true,
    standard: true,
    premium: true,
  },
  {
    id: "basicFilters",
    labelKey: "Basic Filters",
    free: true,
    standard: true,
    premium: true,
  },
  {
    id: "advancedFilters",
    labelKey: "Advanced Filters",
    free: false,
    standard: true,
    premium: true,
  },
  {
    id: "unlimitedLikes",
    labelKey: "Unlimited likes",
    free: false,
    standard: true,
    premium: true,
  },
  {
    id: "messageLikes",
    labelKey: "Message users who liked you",
    free: false,
    standard: true,
    premium: true,
  },
  {
    id: "mutualLikes",
    labelKey: "View mutual likes",
    free: false,
    standard: true,
    premium: true,
  },
  {
    id: "dynamicCards",
    labelKey: "See others' dynamic cards",
    free: false,
    standard: true,
    premium: true,
  },
  {
    id: "games",
    labelKey: "Start games with other users",
    free: false,
    standard: true,
    premium: true,
  },
  {
    id: "matchingAlgorithm",
    labelKey: "Matching algorithm",
    free: false,
    standard: false,
    premium: true,
    premiumExclusive: true,
  },
];

export const getMembershipTier = (tierId = "standard") =>
  membershipTiers.find((tier) => tier.id === tierId) || membershipTiers[0];

export const getMembershipDuration = (durationId = "quarterly") =>
  membershipDurations.find((duration) => duration.id === durationId) ||
  membershipDurations[1];

export const getMembershipPrice = (
  tierId = "standard",
  durationId = "quarterly",
) => {
  const tier = getMembershipTier(tierId);
  const duration = getMembershipDuration(durationId);

  return subscriptionPrices[tier.priceKey][duration.priceKey];
};

export const getMonthlyEquivalent = (
  tierId = "standard",
  durationId = "quarterly",
) => {
  const duration = getMembershipDuration(durationId);

  return getMembershipPrice(tierId, durationId) / duration.months;
};

export const getTierFeatures = (
  tierId = "standard",
  { includeFree = false } = {},
) =>
  membershipFeatures.filter(
    (feature) => feature[tierId] && (includeFree || !feature.free),
  );
